import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, HashRouter } from 'react-router-dom'
import { Capacitor } from '@capacitor/core'
import { AuthProvider } from './contexts/AuthContext'
import { OperationProvider } from './contexts/OperationContext'
import { ErrorBoundary } from './components/ErrorBoundary'
import { startOfflineAutoSync } from './services/offlineSync'
import { startRuntimeProtection } from './services/runtimeProtection'
import App from './App'
import './index.css'

async function desativarServiceWorkerAntigo() {
  if (!('serviceWorker' in navigator)) return

  try {
    const registrations = await navigator.serviceWorker.getRegistrations()
    await Promise.all(registrations.map((registration) => registration.unregister()))

    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(
        keys
          .filter((key) => key.startsWith('agroschelive-'))
          .map((key) => caches.delete(key))
      )
    }
  } catch (error) {
    console.error('Erro ao desativar Service Worker antigo', error)
  }
}

function iniciarTarefasNaoCriticas() {
  window.setTimeout(() => {
    desativarServiceWorkerAntigo()
    startOfflineAutoSync()
    startRuntimeProtection()
  }, 1500)
}

const Router = Capacitor.isNativePlatform() ? HashRouter : BrowserRouter

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <OperationProvider>
            <App />
          </OperationProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  </React.StrictMode>
)

iniciarTarefasNaoCriticas()
